import * as Immutable from 'immutable';
import { Categories } from '../../Module/_config/ModuleInfo';

export interface IModuleCreatorStore {
	opened: boolean
	search: string
	category: string
}

const defaultStore = Immutable.Record<IModuleCreatorStore>({
	opened: false,
	search: '',
	category: Categories.Images
});

export default class ModuleCreatorStore extends defaultStore implements IModuleCreatorStore {}